<template>
  <div>
    <BaseHeadline icon="mdi-calendar-month">
      <template v-slot:headlineBtns>
        <v-btn color="primary" :to="{ name: 'ProjectBooking' }">
          Legg til booking
        </v-btn>
      </template>
    </BaseHeadline>

    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      class="mt-4"
      color="primary"
      large
      block
      depressed
      :to="{ name: 'ProjectBooking' }"
    >
      <v-icon left>mdi-calendar-range</v-icon>
      Legg til booking
    </v-btn>

    <CaseCardList v-model="bookings" removeBottomLoading>
      <template v-slot:title="{ item }">
        {{ item.barrackName }} - {{ item.roomName }}
      </template>

      <template v-slot:topRight="{ item }">
        <v-btn icon @click.stop="deleteBooking(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:chips="{ item }">
        {{ item.location }}
      </template>

      <template v-slot:underLeft="{ item }">
        {{ item.fromDate | moment("ddd DD.MM.YY") }} ~
        {{ item.toDate | moment("ddd DD.MM.YY") }}
      </template>
    </CaseCardList>

    <ConfirmDialog
      v-model="showConfirm"
      title="Bekreft"
      icon="mdi-calendar-remove"
      :text="confirmText"
      btnActionName="Bekreft"
      btnCloseName="Avbryt"
      @action="saveDeleteBooking"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";
import { projectObject } from "@/types/projectInterface";
import barracksApi from "@/api/barracksApi";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import CaseCardList from "@/components/shared/cards/CaseCardList.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";

export default Vue.extend({
  name: "Dashboard",
  data() {
    return {
      enableFollowing: true,
      project: {} as projectObject,
      bookings: [],
      showConfirm: false,
      confirmText: "",
      booking: {},
    };
  },
  async mounted() {
    await this.getBookings();
  },
  methods: {
    async getBookings() {
      await barracksApi
        .getBookingsBarracksProject(this.$route.params.id)
        .then((x) => {
          this.bookings = x;
        });
    },
    deleteBooking(booking) {
      this.booking = booking;
      this.confirmText = `Vil du slette reservasjon på ${
        booking.barrackName
      } - ${booking.roomName} fra ${moment(booking.fromDate).format(
        "dddd DD.MM.YY"
      )} til ${moment(booking.toDate).format("dddd DD.MM.YY")}?`;
      this.showConfirm = true;
    },
    async saveDeleteBooking() {
      await barracksApi
        .delBookingBarracks((this as any).booking.id)
        .then(async () => {
          await this.getBookings();
          this.showConfirm = false;
        });
    },
  },

  components: {
    BaseHeadline,
    CaseCardList,
    ConfirmDialog,
  },
});
</script>
